var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[(_vm.isFetched)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',_vm._b({attrs:{"headers":_vm.headers,"items":_vm.items}},'v-data-table',_vm.tableProps,false))],1):[_c('main-loader',{staticClass:"pt-5"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }